var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDoubleCheck = function SvgDoubleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.738 5.352a1 1 0 1 1 1.524 1.296l-8.5 10a1 1 0 0 1-1.426.1l-4.5-4a1 1 0 1 1 1.328-1.495l3.736 3.32 7.838-9.22z",
    fill: "#335EEA",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.738 6.352a1 1 0 1 1 1.524 1.296l-8.5 10a1 1 0 0 1-1.426.1l-4.5-4a1 1 0 1 1 1.328-1.495l3.736 3.32 7.838-9.22z",
    fill: "#335EEA"
  }))));
};

export { SvgDoubleCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48cGF0aCBkPSJNMjAuNzM4IDUuMzUyYTEgMSAwIDExMS41MjQgMS4yOTZsLTguNSAxMGExIDEgMCAwMS0xLjQyNi4xbC00LjUtNGExIDEgMCAxMTEuMzI4LTEuNDk1bDMuNzM2IDMuMzIgNy44MzgtOS4yMnoiIGZpbGw9IiMzMzVFRUEiIG9wYWNpdHk9Ii4zIi8+PHBhdGggZD0iTTE1LjczOCA2LjM1MmExIDEgMCAxMTEuNTI0IDEuMjk2bC04LjUgMTBhMSAxIDAgMDEtMS40MjYuMWwtNC41LTRhMSAxIDAgMTExLjMyOC0xLjQ5NWwzLjczNiAzLjMyIDcuODM4LTkuMjJ6IiBmaWxsPSIjMzM1RUVBIi8+PC9nPjwvc3ZnPg==";